<template>
  <div>
    <router-view />
  </div>
</template>

<script setup></script>

<style>
* {
  box-sizing: border-box;
}
img {
  pointer-events: none;
}
</style>
